
// Actions
const PREFIX = 'calculus/environments/';

export const SET_ENVIRONMENTS  = PREFIX + 'SET_ENVIRONMENTS';
export const ENVIRONMENT_ITEM_TYPE = 'environment';

const INITIAL_STATE = {
  loading: true,
  data: []
};

import {
  SET_CUSTOMS_ITEMS,

  parseItems
} from './customs';

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_CUSTOMS_ITEMS:
      return {
        ...state,
        data: [
          ...state.data,
          ...parseItems(payload.data, ENVIRONMENT_ITEM_TYPE)
        ]
      };
    case SET_ENVIRONMENTS:
      return {
        ...state,
        data: payload,
        loading: false
      };

    default:
      return state;
  }
}

// Action Creators
export function setEnvironments(payload) {
  return {
    type: SET_ENVIRONMENTS,
    payload: payload
  };
}
